import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import pic11 from '../assets/images/ahbgroup.jpg'
import ahlogo from '../assets/images/ahbusinesslogo.png'
import logo from '../assets/images/AHbusiness-logotipo-4.svg'

const Generic = (props) => (
    <div>
    <Helmet>
    <title>Grupo AH BUSINESS</title>
    <meta name="description" content="AH Business Group" />
    </Helmet>

    <div id="main" className="alt">
    <section id="one">
    <div className="inner">

    <span className="image main"><img src={pic11} alt="" /></span>
    <p>Os fundadores, em plena sintonia sobre as necessidades
    fundamentais para a viabilização da empresa, sabiam que a
    capacidade empreendedora de uns não seria sustentável sem
    a capacidade de gestão de outros. A vontade de fazer crescer
    a AH BUSINESS tem assim, associada à capacidade de
    visualizar oportunidades de negócio, a capacidade de lhes dar
    corpo e vida. A história profissional e pessoal de cada um é,
    através da AH BUSINESS, assimilada e conduzida no sentido
    de lhe proporcionar um “nascimento” seguro e um crescimento
    com futuro.</p>

    <p> O resultado final não será igual à soma das partes mas
    procurará ter o que de melhor existe em cada uma e, ao
    mesmo tempo, aprender a proteger-se das suas debilidades.</p>

    <p>A AH Business tem uma estrutura sólida, o que lhe permite
    adaptar-se à evolução da sociedade e dos mercados, bem
    como ter legítimas aspirações de continuar a ver reconhecidas,
    no futuro, a sua competência e eficiência técnica, e de gestão.</p>

    <p>O âmbito de intervenção da AH Business, através das
    empresas direta ou indiretamente participadas, estende-se aos
    sectores de atividade da Saúde, Educação, Marketing,
    Consultoria, Tecnologias de Informação e Participações
    Financeiras. As diversas empresas e as suas participadas
    atuam com grande proximidade, procurando maximizar as
    sinergias dentro do Grupo AH Business e contribuir para o seu
    crescimento sustentado.</p>

    </div>
    </section>
    </div>

    </div>
    )

export default Generic



// WEBPACK FOOTER //
// ./src/pages/group.js